/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  checkPayeeCode: [],
  checkPayValue: '',
  displayOptionValue: 'Detail',
  fromDateValue: '',
  toDateValue: '',
  checkAllocationComparisionData: [],
  allErrors: [],
  isLoading: false,
  displayObj: {
    checkPayeeCode: [],
    displayOptionValue: 'Detail',
    fromDateValue: '',
    toDateValue: '',
    checkAllocationComparisionData: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CHECK_PAYEE_COMPARISION:
      return { ...state, checkPayeeCode: action.checkPayeeCode };
    case actionTypes.SET_SELECTED_INPUT_COMPARISION:
      return { ...state, ...action.payload };
    case actionTypes.SET_ALLOCATION_COMPARISION_DATA:
      let displayObj = {
        ...state,
        checkAllocationComparisionData: action.payload,
      };
      return {
        ...state,
        checkAllocationComparisionData: action.payload,
        displayObj,
      };
    case actionTypes.SET_ALL_REBATE_PROGRAM_DATA:
      return {
        ...state,
        rebateDropdownData: action.payload,
      };
    case actionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case actionTypes.REFRESH_CHECK_ALLOCATION_COMPARISION:
      return {
        ...state,
        checkPayeeCode: [],
        checkPayValue: '',
        displayOptionValue: 'Detail',
        fromDateValue: '',
        toDateValue: '',
        checkAllocationComparisionData: [],
        allErrors: [],
        displayObj: state.displayObj,
      };
    case actionTypes.REFRESH_DATA_CHECK_ALLOCATION_COMPARISON_DISPLAY:
      return {
        ...state,
        displayObj: {
          checkPayeeCode: [],
          displayOptionValue: 'Detail',
          fromDateValue: '',
          toDateValue: '',
          checkAllocationComparisionData: [],
        },
      };
    default:
      return state;
  }
};

export default reducer;
